// extracted by mini-css-extract-plugin
export default {"root":"replay_root__nTLYM","alert":"replay_alert__ZOoC9"};